import React, { useEffect, useState, useCallback, useRef } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "react-medium-image-zoom/dist/styles.css";
import { getPro, savePro, saveSeries, getSeries } from "../db";
import Footer from "./Footer";
import Header from "./Header";

function MyProducts() {
  const order_count = 2;
  const dealer_id = localStorage.getItem("dealer_id");
  const server_url = localStorage.getItem("server_url");
  const LoginNumber = localStorage.getItem("LoginNumber");
  const [searchTerm, setSearchTerm] = useState("");
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [series, setSeries] = useState([]);
  const [refreshBanner, setRefreshBanner] = useState(false);
  const [selectedSeries, setSelectedSeries] = useState(null);
  const [showSearch, setShowSearch] = useState(false);
  const location = useLocation();
  const { pathname } = location;
  const searchInputRef = useRef(null);
  const navigate = useNavigate();

  // Fetch Banner Data
  const getProducts = useCallback(async () => {
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("dealer_id", dealer_id);

      const res = await axios.post(
        `${server_url}released_item_list.php`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      
      if (res.data.status == "1") {
        savePro(res.data.result.dealer_portfolio);
        setData(res.data.result.dealer_portfolio);
        setFilteredData(res.data.result.dealer_portfolio);
      } else {
        savePro([]);
        setData([]);
        setFilteredData([]);
      }
    } catch (e) {
      toast("Please Try After Some Time.");
    }
  }, [dealer_id, server_url]);

  const getSerices = async () => {
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      const res = await axios.post(`${server_url}series_list.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.data.status === "1") {
        setSeries(res.data.result);
        saveSeries(res.data.result);
      } else {
        setSeries([]);
        saveSeries([]);
      }
    } catch (e) {
      toast("Please Try After Some Time.");
    }
  };

  useEffect(() => {
    if (!LoginNumber || LoginNumber.trim() === "" || !dealer_id) {
      const currentPath = location.pathname + location.search;
      localStorage.setItem("login_url", currentPath);
      navigate("/Logout");
      return;
    }
    async function loadCachedData() {
      const cachedData = await getPro();
      if (cachedData) setData(cachedData);

      const cachedSeries = await getSeries();
      if (cachedSeries) setSeries(cachedSeries);
    }
    loadCachedData();
    getProducts();
    getSerices();
  }, [getProducts]);

  useEffect(() => {
    if (refreshBanner) {
      getProducts();
      setRefreshBanner(false);
    }
  }, [refreshBanner, getProducts]);

  // Local search function
  const handleSearch = (term) => {
    setSearchTerm(term);

    if (!term.trim()) {
      setFilteredData(data);
      return;
    }

    const filtered = data.filter((product) => {
      const searchLower = term.toLowerCase();
      return (
        (product.product_name &&
          product.product_name.toLowerCase().includes(searchLower)) ||
        (product.product_design_name &&
          product.product_design_name.toLowerCase().includes(searchLower)) ||
        (product.product_code &&
          product.product_code.toLowerCase().includes(searchLower)) ||
        (product.product_series_name &&
          product.product_series_name.toLowerCase().includes(searchLower))
      );
    });

    setFilteredData(filtered);
  };

  const handleSearchIconClick = () => {
    setShowSearch(true);
    setTimeout(() => {
      if (searchInputRef.current) {
        searchInputRef.current.focus();
      }
    }, 100);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    setFilteredData(data);
    setShowSearch(false);
  };

  const handleBackClick = () => {
    if (showSearch) {
      setShowSearch(false);
      setSearchTerm("");
      setFilteredData(data);
    } else {
      navigate(-1);
    }
  };

  return (
    <>
    <Header />
      <div
        className="page-content header-clear-small"
        style={{
          padding: "0px 10px",
          background: "#ffffff",
          minHeight: "100vh",
        }}
      >
       
     

        {/* Product Grid */}
        <div className="page-content">
          <div className="row mb-0" style={{ padding: "0px 5px" }}>
            {filteredData.map((product, index) => (
              <div
                key={index}
                className="col-6 col-md-4 col-lg-3 mb-3"
                style={{ padding: "5px" }}
              >
                <Link
                  to={`/ProductDetails/${
                    product.product_id
                  }/${product.product_design_name
                    .trim()
                    .split(/\s+/)
                    .map(
                      (word) =>
                        word.charAt(0).toUpperCase() +
                        word.slice(1).toLowerCase()
                    )
                    .join("")}`}
                  style={{ textDecoration: "none" }}
                >
                  <div
                    className="card card-style product-card"
                    style={{
                      height: "100%",
                      background: "#ffffff",
                      border: "1px solid #e5e5e5",
                      borderRadius: "12px",
                      overflow: "hidden",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-5px)";
                    
                      e.currentTarget.style.borderColor = "#db4437";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                   
                      e.currentTarget.style.borderColor = "#e5e5e5";
                    }}
                  >
                    {/* Product Image */}
                    <div
                      className="image-container"
                      style={{ position: "relative" }}
                    >
                      <img
                        src={product.product_image}
                        style={{
                          width: "100%",
                          height: "299px",
                          objectFit: "cover",
                          borderBottom: "1px solid #f0f0f0",
                        }}
                        className="img-fluid"
                        alt={product.product_design_name}
                        onError={(e) => {
                          e.target.src =
                            "https://via.placeholder.com/300x200/f0f0f0/666666?text=No+Image";
                        }}
                      />

                      {/* Pack Badge */}
                      <div
                        style={{
                          position: "absolute",
                          top: "8px",
                          right: "8px",
                          background: "rgba(0,0,0,0.8)",
                          color: "#ffffff",
                          padding: "2px 8px",
                          borderRadius: "10px",
                          fontSize: "10px",
                          fontWeight: "600",
                        }}
                      >
                        Pack of {product.product_piece_per_box}
                      </div>
                    </div>

                    {/* Product Info */}
                    <div
                      className="content p-3"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        flex: 1,
                      }}
                    >
                      {/* Product Name */}
                      <h5
                        className="mb-2"
                        style={{
                          fontSize: "14px",
                          fontWeight: "600",
                          color: "#000000",
                          lineHeight: "1.3",
                          height: "36px",
                          overflow: "hidden",
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                        }}
                      >
                        {product.product_design_name}
                      </h5>

                      {/* Product Details */}
                      <div className="product-details">
                        {/* Price Section */}
                        {order_count === "1" && (
                          <div className="price-section mb-2">
                            {product.product_dealer_price !==
                              product.product_mrp && (
                              <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "400",
                                  textDecoration: "line-through",
                                  color: "#999999",
                                  marginRight: "5px",
                                }}
                              >
                                ₹{product.product_mrp}
                              </span>
                            )}
                            <span
                              style={{
                                fontSize: "16px",
                                fontWeight: "700",
                                color: "#10b981",
                              }}
                            >
                              ₹{product.product_dealer_price}
                            </span>
                          </div>
                        )}

                        {/* Additional Info */}
                        <div className="additional-info">
                          {product.product_code && (
                            <div
                              style={{
                                fontSize: "11px",
                                color: "#666666",
                                marginBottom: "2px",
                              }}
                            >
                              Code: {product.product_code}
                            </div>
                          )}

                          {product.product_series_name && (
                            <div
                              style={{
                                fontSize: "11px",
                                color: "#666666",
                              }}
                            >
                              Series: {product.product_series_name}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>

          {/* Empty State */}
          {filteredData.length === 0 && (
            <div className="text-center py-5">
              <div
                style={{
                  color: "#666666",
                  fontSize: "16px",
                  marginTop: "50px",
                }}
              >
                <i
                  className="fa fa-search fa-3x mb-3"
                  style={{ color: "#999999" }}
                ></i>
                <br />
                {searchTerm
                  ? "No products found for your search"
                  : "No products available"}
                {searchTerm && (
                  <div style={{ fontSize: "14px", marginTop: "10px", color: "#666666" }}>
                    Try adjusting your search terms
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />

      <style jsx>{`
      .card-style{
          box-shadow: 0 0px 0px 0 ;
      }
        .product-card:hover .view-details-btn {
          background: rgba(219, 68, 55, 0.1) !important;
          transform: scale(1.05);
        }

        .content {
          margin: -7px 0px -35px 0px;
        }

        .image-container::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 30px;
          background: linear-gradient(transparent, rgba(255, 255, 255, 0.8));
          pointer-events: none;
        }

        /* Responsive design */
        @media (max-width: 768px) {
          .header {
            padding: 12px 10px !important;
          }
        }

        @media (max-width: 480px) {
          .header > div {
            gap: 8px !important;
          }
        }
      `}</style>
    </>
  );
}

export default MyProducts;